import React from 'react';

interface PriceLineProps {
  price: string;
  desc?: string;
  isFirst?: boolean;
}

function PriceLine({ price, desc, isFirst }: PriceLineProps) {
  const priceClass = isFirst
    ? 'text-[10vw] s1000:text-[7vw]'
    : 'text-[6vw] s1000:text-[5vw]';

  return (
    <div className="mb-6 flex items-center justify-between border-b-4 border-secondary px-4 s1000:text-left">
      <span className="text-[6vw] font-semibold s1000:text-[5vw]">{price}</span>
      {desc && (
        <span className={`${priceClass}  font-semibold`}>
          {desc}
        </span>
      )}
    </div>
  );
}

PriceLine.defaultProps = {
  desc: '',
};

export default PriceLine;
